/** A retained decoder frame stays the source of detection, warp and OCR across awaits. */
export type PixelSource = HTMLVideoElement | VideoFrame;

export function pixelSize(source: PixelSource): { width: number; height: number } {
  return "videoWidth" in source
    ? { width: source.videoWidth, height: source.videoHeight }
    : { width: source.displayWidth, height: source.displayHeight };
}

export function retainFrame(video: HTMLVideoElement): PixelSource {
  try {
    if (typeof VideoFrame !== "undefined") return new VideoFrame(video);
  } catch {
    /* older decoder */
  }
  return video;
}

export function releaseFrame(source: PixelSource | null): void {
  if (source && !("videoWidth" in source)) source.close();
}
